/**
 * The newest redacted output on a TDO — the one every caller means by "the
 * redacted file": what the top bar links to, what a download hands over, whose
 * metrics the tab shows, and which output the staleness check judges.
 *
 * Newest by `createdDateTime`, the burn-in time. It used to be
 * `modifiedDateTime`, which is bumped whenever an asset's metrics are rewritten
 * — downloading an output increments its counter — so downloading an older
 * version moved it back to the front and every caller above then described the
 * wrong file (VE-25870). `modifiedDateTime` remains the fallback: assets burned
 * in before `createdDateTime` was selected carry only the latter.
 */
import { DetailTDO } from '@common-modules/mediaDetails/models';
import { has, maxBy } from 'lodash';

export default function getLastRedactedFile(tdo: DetailTDO | null) {
  if (!tdo || !has(tdo, 'redactedMediaAssets.records')) {
    return null;
  }

  return maxBy(tdo?.redactedMediaAssets?.records || [], (asset) =>
    new Date(asset.createdDateTime || asset.modifiedDateTime || 0).getTime()
  );
}
